import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/69/thumb-landscape.png"

const Post69 = ({ data: { allCategoryJson, postsJson }, location }) => {

  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>「シャネルのバッグ、いつか欲しい」——そう思いながら、なかなか決断できずにいませんか？</p>
          <p>定番のマトラッセ（クラシック スモール ハンドバッグ）は2025〜2026年時点で170万円台。スタンダードなマトラッセ25に至っては177万円超と、今やシャネルのバッグは「気軽に買える価格」ではなくなりつつあります。「買えないことはない。でも、本当に毎日使うかな？」「流行が変わったらどうしよう」「傷つけたら？」——こうした迷いが、購入の背中を押すことを躊躇させます。</p>
          <p>この記事では、シャネルのバッグを「買う」場合と「サブスクで借りる」場合を、費用・リスク・体験の3軸で徹底比較します。どちらが"得"かは人によって違いますが、この記事を読めば、あなたにとってベストな答えが見えてくるはずです。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;まず「現実の価格」を整理する</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;「買う」場合のコスト全体像</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;「借りる（サブスク）」場合のコスト</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;3軸で比較：費用・リスク・体験</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>5 |</span>&nbsp;&nbsp;「買う前に借りてみる」という選択肢</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>6 |</span>&nbsp;&nbsp;こんな人は「買う」が向いている</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>7 |</span>&nbsp;&nbsp;こんな人は「借りる」が向いている</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec8" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>8 |</span>&nbsp;&nbsp;まとめ：どちらが「得」かは、あなたの使い方次第</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec9" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>9 |</span>&nbsp;&nbsp;よくある質問</ScrollLink>
          </div>
        </p>
      </div>
      <section name="sec1" className="section-content">
        <h2>まず「現実の価格」を整理する</h2>
        <p>シャネルのバッグは、この数年で大幅に値上がりしています。</p>
        <p>コロナ禍以降、シャネルは年3〜4回のペースでサイレント値上げを繰り返してきました。かつて10年前は40〜50万円で購入できたマトラッセチェーンショルダーは、2025年1月の改定でマトラッセ23・25が170万円を突破。2026年時点ではさらに上昇し、177万円超のモデルも。20年前（15〜20万円）と比較すると、約9倍にまで高騰しています（参考：komehyo.jp「ブランドの手帳」2025年）。</p>
        <p>つまり、「いつか買おう」と思っている間に、購入のハードルはどんどん上がっているのが現実です。</p>
        <p>では、実際に「買う」と「借りる」を比べると、費用面でどのくらい差があるのでしょうか。</p>
      </section>
      <section name="sec2" className="section-content">
        <h2>「買う」場合のコスト全体像</h2>
        <p>シャネルのバッグを購入する場合、払うのは定価だけではありません。</p>
        <div className="mt4">
          <h3>初期費用（購入価格）</h3>
          <p>人気の定番モデルを例にとると（2025〜2026年・参考価格）：</p>
          <ul className="list-style-disc" style={{marginTop: "2rem"}}>
            <li>クラシック スモール ハンドバッグ（マトラッセ23）：約168〜176万円</li>
            <li>クラシック ハンドバッグ（マトラッセ25）：約174〜178万円</li>
            <li>クラシック ラージ ハンドバッグ（マトラッセ30）：約188〜190万円</li>
          </ul>
          <p>※上記は参考価格です。最新の正確な価格はシャネル公式サイト・正規店でご確認ください。</p>
        </div>
        <div className="mt4">
          <h3>維持費用（見落とされがちなコスト）</h3>
          <p>購入後も、バッグには維持コストがかかります。</p>
          <ul className="list-style-disc" style={{marginTop: "2rem"}}>
            <li>保管・メンテナンス：型崩れや変色を防ぐための保管グッズ、クリーニング費用（年1〜2回で5,000〜20,000円が目安）</li>
            <li>修理代：金具の修理、内張りの交換など（数万円〜）</li>
            <li>保険：高価なバッグは盗難・紛失リスクもあり、動産保険に入る人も</li>
          </ul>
        </div>
        <div className="mt4">
          <h3>機会コスト</h3>
          <p>150万〜190万円という大きな資金を一度に使ってしまうことで、他への投資や活用ができなくなります。</p>
        </div>
      </section>
      <section name="sec3" className="section-content">
        <h2>「借りる（サブスク）」場合のコスト</h2>
        <p>ラクサスの場合、月額9,800円（税込10,780円）で60ブランド・約30,000点のバッグが使い放題です。シャネルのバッグも何度でも借りられます。</p>
        <div className="mt4">
          <h3>年間費用のシミュレーション</h3>
          <div className="table-wrap">
            <table className="table table--row">
              <thead>
                <tr>
                  <th>利用スタイル</th>
                  <th>年間費用</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>月1回交換（荷造り手数料なし）</td>
                  <td>約129,360円/年</td>
                </tr>
                <tr>
                  <td>月2〜3回交換（手数料込み）</td>
                  <td>約142,560円〜/年</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <p>シャネルのバッグ（マトラッセ25）を約177万円で買うとすると、ラクサスの月額に換算すると約14年分に相当します。その間、シャネルだけでなく、エルメス・ルイ・ヴィトン・セリーヌ・ロエベなど60ブランドを自由に使い続けられる計算です。</p>
        <figure className="mt4">
          <StaticImage src="../../images/posts/69/1.png" alt="様々なバッグがならぶスナップイメージ"/>
        </figure>
      </section>
      <section name="sec4" className="section-content">
        <h2>3軸で比較：費用・リスク・体験</h2>
        <div>
          <h3>① 費用面</h3>
          <div className="table-wrap">
            <table className="table table--row">
              <thead>
                <tr>
                  <th>比較項目</th>
                  <th>買う</th>
                  <th>借りる（ラクサス）</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>初期費用</td>
                  <td>170万〜190万円以上（主要モデル）</td>
                  <td>0円（月額のみ）</td>
                </tr>
                <tr>
                  <td>年間維持コスト</td>
                  <td>数万円（クリーニング・修理等）</td>
                  <td>含まれる（補償付き）</td>
                </tr>
                <tr>
                  <td>複数ブランドを楽しむ場合</td>
                  <td>1本ごとに購入が必要</td>
                  <td>同じ月額で何度でも交換可</td>
                </tr>
                <tr>
                  <td>解約・出口</td>
                  <td>売却（価値の変動あり）</td>
                  <td>いつでも利用停止可</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>ポイント：「1ブランドを長く深く愛用したい」人には購入が向いています。一方、「シーンや季節で使い分けたい」「いろんなブランドを試したい」人にとっては、サブスクのほうが圧倒的にコスパが良くなります。</p>
        </div>
        <div className="mt4">
          <h3>② リスク面</h3>
          <p>ブランドバッグの購入には、複数のリスクが伴います。</p>
          <h4>購入する場合のリスク</h4>
          <ul className="list-style-disc">
            <li>傷・汚れ：自分でつけてしまうと資産価値が大きく下がる。使うたびに緊張してしまう人も</li>
            <li>盗難・紛失：高価なバッグほど盗難リスクも高い</li>
            <li>飽き・ライフスタイルの変化：結婚、出産、転職などで「このバッグが合わない」と感じることも</li>
            <li>偽物リスク：フリマサイトや非正規ルートでは精巧な偽物も流通しており、専門知識なしに真贋を判断するのは困難</li>
          </ul>
          <h4>借りる場合のリスク対策（ラクサスの例）</h4>
          <ul className="list-style-disc">
            <li>通常使用によるキズ・汚れは補償対象。返却時のルールが明確</li>
            <li>全バッグが専門鑑定士による鑑定済みなので偽物ゼロ</li>
            <li>「飽きた」「似合わなかった」場合も、次のバッグに交換するだけ</li>
            <li>往復送料無料、返却期限なし</li>
          </ul>
        </div>
        <div className="mt4">
          <h3>③ 体験面</h3>
          <p>「バッグを持つこと」の本質は、所有することではなく、使っているときの気分や体験ではないでしょうか。</p>
          <h4>購入した場合</h4>
          <ul className="list-style-disc">
            <li>自分のものになる達成感・愛着</li>
            <li>長く使うことで育つ「エイジング」の楽しみ</li>
            <li>一方で、「高かったから」と似合わなくても使い続けてしまうことも</li>
          </ul>
          <h4>借りた場合</h4>
          <ul className="list-style-disc">
            <li>今の自分に本当に似合うバッグを、そのとき選べる</li>
            <li>結婚式・面接・旅行など、シーンに合わせて最適なバッグを選択可能</li>
            <li>「このバッグ、思ったより出番が少なかった」というロスがない</li>
            <li>憧れのブランドを試してから、「やっぱり購入しよう」と判断できる</li>
          </ul>
        </div>
      </section>
      <section name="sec5" className="section-content">
        <h2>「買う前に借りてみる」という選択肢</h2>
        <p>意外と見落とされがちなのが、「購入前のお試し」としてサブスクを活用するという使い方です。</p>
        <p>「このバッグ、ずっと欲しいと思ってたけど、実際に使ったら思ったより出番が少なかった」というのは、高級バッグあるあるです。</p>
        <p>サブスクで1〜2ヶ月実際に使ってみてから購入を決断することで、「後悔する買い物」を防げます。逆に「やっぱりこれは自分のものにしたい！」という確信を持った上で購入できるので、満足度も上がります。</p>
        <figure className="mt4">
          <StaticImage src="../../images/posts/69/2.png" alt="スマートフォンのアプリでバッグを選ぶ手元"/>
        </figure>
      </section>
      <section name="sec6" className="section-content">
        <h2>こんな人は「買う」が向いている</h2>
        <ul className="list-style-disc" style={{marginTop: "2rem"}}>
          <li>同じバッグを長年愛用し、革のエイジングを楽しみたい</li>
          <li>特定のモデルへの強いこだわりがあり、手元に置きたい</li>
          <li>バッグを資産・コレクションとして捉えている</li>
          <li>将来的に売却・譲渡も視野に入れている</li>
        </ul>
      </section>
      <section name="sec7" className="section-content">
        <h2>こんな人は「借りる」が向いている</h2>
        <ul className="list-style-disc" style={{marginTop: "2rem"}}>
          <li>季節や気分でバッグを使い分けたい</li>
          <li>結婚式・入学式・面接など、特別なシーンにふさわしいバッグが欲しい</li>
          <li>憧れのブランドを試してみたいが、購入はまだ迷っている</li>
          <li>産休・育休中など、ライフスタイルが変化中</li>
          <li>高価な買い物のリスクを避けたい</li>
        </ul>
      </section>
      <section name="sec8" className="section-content">
        <h2>まとめ：どちらが「得」かは、あなたの使い方次第</h2>
        <p>シャネルのバッグを「買う」のも「借りる」のも、どちらが絶対に正解ということはありません。</p>
        <p>ただ、「使えるかどうかわからないまま170万〜190万円を使う」のは、誰にとってもリスクのある決断です。</p>
        <p>ラクサスなら月額9,800円（税込10,780円）で、シャネルをはじめ60ブランドのバッグを実際に手に取り、使い、試すことができます。往復送料無料・返却期限なし・キズ補償付きなので、初めての方でも安心してスタートできます。</p>
        <p>「まず試してみる」——その一歩が、あなたにとってベストなバッグとの出会いにつながるかもしれません。</p>
      </section>
      <section name="sec9" className="section-content">
        <h2>よくある質問</h2>
        <dl className="faq-item">
          <dt>Q. ラクサスでシャネルのバッグは本当に借りられますか？</dt>
          <dd>
            <p>A. はい、シャネルをはじめルイ・ヴィトン、エルメス、グッチなど60ブランドのバッグが対象です。すべて専門の鑑定士が真贋を確認した本物のみを取り扱っています。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. バッグを傷つけてしまったらどうなりますか？</dt>
          <dd>
            <p>A. 通常の使用による細かいキズや汚れは補償の対象です。安心してお使いください。なお、明らかな破損や紛失の場合は別途ご相談となります。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. 解約はいつでもできますか？</dt>
          <dd>
            <p>A. はい、最低利用期間はありません。バッグを返却し、アプリから利用停止申請をするだけで、いつでも停止できます。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. 月に何回でもバッグを交換できますか？</dt>
          <dd>
            <p>A. 交換回数に制限はありません。ただし、同じ月の2回目以降の交換には荷造り手数料1,100円（税込）がかかります。往復の送料は何回でも無料です。</p>
          </dd>
        </dl>
        <div className="border"></div>
        <p>そんな方におすすめなのが、ブランドバッグシェアリングサービス「ラクサス」です。<br></br>
        アプリで簡単に注文でき、自宅にいながら憧れのシャネルのバッグを実際に使って体験できます。</p>
        <p>📱憧れを日常に──ラクサスでシャネルを体験しよう！</p>
        <Link to="https://laxus.co/app/pc/bags/chanel" className="view-all-button">シャネルのバッグはこちら</Link>
      </section>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post69

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 69}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
